/*Service*/
import {
  ChargeServiceClient,
  ListChargeRequest,
  ProcessChargeRequest,
} from '../proto/stockborrowpb/charge_grpc_web_pb';

import { auth } from '../lib/auth/Auth';
import { stringToProtoDate } from './ConvertService';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new ChargeServiceClient(
  window.env.GRPC_ENDPOINT,
  {},
  { ...auth }
);

export async function listCharge(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListChargeRequest();
    req.setFromTradeDate(stringToProtoDate(param.fromTradeDate));
    req.setToTradeDate(stringToProtoDate(param.toTradeDate));
    req.setDateType(param.dateType);
    req.setCorrespondent(param.correspondent);
    req.setAccountNo(param.accountNo);
    req.setSymbol(param.symbol);
    req.setCusip(param.cusip);
    req.setStatus(param.status);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listCharge(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function processCharge(param) {
  return new Promise((resolve, reject) => {
    const req = new ProcessChargeRequest();
    req.setFromTradeDate(stringToProtoDate(param.fromTradeDate));

    service.processCharge(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
